module.exports = __webpack_public_path__ + "static/project-cod-a8c387e7f031fb3e4c5f33676332f05f.jpg";